import { createRouter, createWebHashHistory } from "vue-router";

import Home from "@/views/HomePage.vue";

// About Nav
import AboutView from "@/views/about/AboutPageView.vue";
import LeadershipMessageView from "@/views/about/LeadershipMessageView.vue";
import PrincipalMessageView from "@/views/about/PrincipalMessageView.vue";
import StaffView from "@/views/about/StaffView.vue";
import CampusView from "@/views/about/CampusView.vue";

// Academics
import PrePrimaryView from "@/views/academics/PrePrimaryView.vue";
import PrimaryView from "@/views/academics/PrimaryView.vue";
import SecondaryView from "@/views/academics/SecondaryView.vue";
import HigherSecondaryView from "@/views/academics/HigherSecondaryView.vue";

// Admission

import AdmissionView from "@/views/admission/AdmissionView.vue";
import FeesView from "@/views/admission/FeesView.vue";
import ScholarshipView from "@/views/admission/ScholarshipView.vue";


// Activities
import HouseView from "@/views/activity/HouseView.vue";
import ExtracurricularView from "@/views/activity/ExtracurricularView.vue";
import AcademyView from "@/views/activity/AcademyView.vue";
import TopperListView from "@/views/activity/TopperListView.vue";

// Media
import GalleryView from "@/views/media/GalleryView.vue";

// Contact
import ContactView from "@/views/ContactView.vue";


import NotFound from "@/components/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },

  // about
  {
    path: "/about",
    name: "About",
    component: AboutView,
  },
  {
    path: "/leadership",
    name: "Leadership",
    component: LeadershipMessageView,
  },
  {
    path: "/principal",
    name: "Principal",
    component: PrincipalMessageView,
  },
  {
    path: "/staff",
    name: "Staff",
    component: StaffView,
  },
  {
    path: "/campus",
    name: "Campus",
    component: CampusView,
  },
  // academics

  {
    path: "/admission",
    name: "Admission",
    component: AdmissionView,
  },
  {
    path: "/fees",
    name: "Fees",
    component: FeesView,
  },
  {
    path: "/scholarship",
    name: "Scholarship",
    component: ScholarshipView,
  },
  // Admission

  {
    path: "/preprimary",
    name: "PrePrimary",
    component: PrePrimaryView,
  },
  {
    path: "/primary",
    name: "Primary",
    component: PrimaryView,
  },
  {
    path: "/secondary",
    name: "Secondary",
    component: SecondaryView,
  },
  {
    path: "/highersecondary",
    name: "HigherSecondary",
    component: HigherSecondaryView,
  },

  // Activities
  {
    path: "/houses",
    name: "Houses",
    component: HouseView,
  },
  {
    path: "/extracurricular",
    name: "Extracurricular",
    component: ExtracurricularView,
  },
  {
    path: "/academy",
    name: "Academy",
    component: AcademyView,
  },

  {
    path: "/topper-list",
    name: "TopperList",
    component: TopperListView,
  },

  // Media
  {
    path: "/gallery",
    name: "Gallery",
    component: GalleryView,
  },

  // Contact
  {
    path: "/contact",
    name: "Contact",
    component: ContactView,
  },


  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
